import React from "react";
import { NavLink } from "react-router-dom";
import { HiOutlineHome, HiOutlineBuildingOffice2, HiOutlinePlus, HiOutlineClipboardDocumentList, HiOutlineHeart } from "react-icons/hi2";
import ROUTES from "../../../config/routes";
import { useLanguage, t } from "../../../i18n";
import "./BottomNavigation.css";

const items = [
  { label: "Home", path: ROUTES.HOME, icon: HiOutlineHome },
  { label: "Room Listings", path: ROUTES.LISTINGS, icon: HiOutlineBuildingOffice2 },
  { label: "Post Room", path: ROUTES.CREATE_LISTING, icon: HiOutlinePlus, primary: true },
  { label: "My Posts", path: ROUTES.MY_LISTINGS, icon: HiOutlineClipboardDocumentList },
  { label: "Shortlist", path: ROUTES.SHORTLIST, icon: HiOutlineHeart },
];

export default function BottomNavigation() {
  const { language } = useLanguage();
  return <nav className="bb-bottom-nav" aria-label={t("Main navigation")} dir={language === "ar" ? "rtl" : "ltr"}>
    <div className="bb-bottom-nav__items">
      {items.map(({ label, path, icon: Icon, primary }) => (
        <NavLink key={path} to={path} className={({ isActive }) =>
          `bb-bottom-nav__link${primary ? " bb-bottom-nav__link--primary" : ""}${isActive ? " active" : ""}`}>
          <span className="bb-bottom-nav__icon"><Icon aria-hidden="true" /></span>
          <span className="bb-bottom-nav__label">{t(label)}</span>
        </NavLink>
      ))}
    </div>
  </nav>;
}
